import React, { useState, useEffect } from "react";
import "../styles/quickddx.css";
import { toast } from "react-toastify";
import {
  useGetProfileQuery,
  useUpdateProfileMutation,
  useGetSubscriptionsQuery,
} from "../store/profile/UserApiSlice";
import app_api from "../config/Api";
import config from "../config/APIEndpoints";
import { data } from "autoprefixer";
import { use } from "react";
const LoaderAnimation =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/paymentloader.gif";
const clipicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/diagnose/clip.svg";
const FreeTrialIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/freepopup.svg";
const FreeTrialText =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/freetrialtext.svg";

const crossicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/lounge/crossicon.svg";
export default function SubscriptionLoader({ isVisible, onClose, header }) {
  const [timeLeft, setTimeLeft] = useState(120);
  useEffect(() => {
    if (isVisible === true) {
      setTimeLeft(120);
    }
  }, [isVisible]);
  useEffect(() => {
    if (timeLeft === 0) {
      onClose();
      window.location.reload();
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;

  if (!isVisible) return null;
  return (
    <div className="popup-overlay">
      {/* <div className="freetrialpopup" onClick={(e) => e.stopPropagation()}>
        <img src={FreeTrialIcon} alt="Free Trial" />
        <div className="freetrialbody">
          <button className="introofferbutton paymentofferbutton">
            {header}
          </button>
          <p>Awaiting Razorpay’s Confirmation for the Refundable Payment</p>

          <p>{formattedTime}</p>
        </div>
        <div className="freetrialbottomtext">
          <p className="freetrialtextsmall">Please do not refresh the page</p>
        </div>
      </div> */}
      <div className="fullscreenpayment" onClick={(e) => e.stopPropagation()}>
        <img src={LoaderAnimation} alt="Loader" />
        <h4>Processing Payment</h4>
        <p>
          Awaiting Razorpay’s Confirmation
          <br />
          Website will automatically refresh once payment is processed.
        </p>

        <h5>{formattedTime}</h5>
        <div className="freetrialbottomtext">
          <p className="freetrialtextsmall">Please do not refresh the page</p>
        </div>
      </div>
    </div>
  );
}
